export default __webpack_public_path__ + "static/media/amsterdam.eaae1ffa.jpg";